import { InjectionToken } from "@angular/core";

export interface IConfig {
  domain: string;
}

export const LANGUAGE_CONFIG = new InjectionToken<IConfig>("language-config");
